import { useState } from 'react';
import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';

import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { useScrollAnimation, cn } from '../../scroll-animation-v2';

export default function Risk() {
    const { locale } = getLocal();

    const { t } = useLang('powerbackup');
    const [active, setActive] = useState(0);
    const [animatingIndex, setAnimatingIndex] = useState<number | null>(null);

    const { ref, isVisible } = useScrollAnimation({
        threshold: 0.1,
    });

    const cards: any = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747216699942/1.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1747216698445/1-h5.jpg',
            title: t('secC_list1_title'),
            desc: t('secC_list1_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1769069128072-qbo56p-compressed-Frame%202094654854.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/figma-uploads/1769069155820-jek04f-compressed-full-width-carousel.jpg',
            title: t('secC_list2_title'),
            desc: t('secC_list2_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747216699565/3.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1747216699074/3-h5.jpg',
            title: t('secC_list3_title'),
            desc: t('secC_list3_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747216698603/4.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1747216699795/4-h5.jpg',
            title: t('secC_list4_title'),
            desc: t('secC_list4_desc'),
        },
    ];

    const onMouseEnter = (k: number) => {
        if (k !== active) {
            setAnimatingIndex(k);
            setActive(k);
            // 动画完成后取消 animating 状态
            setTimeout(() => {
                setAnimatingIndex(null);
            }, 600);
        }
    };

    const [swiper, setSwiper] = useState<any | null>(null);

    return (
        <div ref={ref} className={`${styles.Risk} GtmModuleData-section`}>
            <p className={`${cn(isVisible, 'power-backup-title fade-up')} `}>{t('secC_title')}</p>

            <ul className={`${cn(isVisible, 'card-box fade-up')} `} style={{ '--animate-delay': '0.15s' } as React.CSSProperties}>
                {cards?.map((card: any, k: number) => (
                    <li
                        className={`card card${k} ${k === active ? 'active' : ''} ${k === animatingIndex ? 'animating' : ''}`}
                        key={k}
                        onMouseEnter={() => onMouseEnter(k)}
                    >
                        <div className="card-img">
                            <EFPicture src={card?.img} alt={card?.title} />
                        </div>
                        <div className="card-text">
                            <p className="card-title">{card?.title}</p>
                            <p className="card-desc">{card?.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>

            <Swiper
                className="swiper-box"
                effect="fade"
                modules={[Scrollbar, Navigation]}
                spaceBetween={16}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 25,
                    snapOnRelease: true,
                }}
                onSwiper={(swipwerIns: any) => {
                    setSwiper(swipwerIns);
                }}
            >
                {cards?.map((item: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <div className="item-img">
                            <EFPicture src={item?.img} srcPad={item?.imgPad} alt={item?.title} />
                        </div>
                        <div className="item-text">
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                        </div>
                    </SwiperSlide>
                ))}

                <div className="swiper-button-box">
                    <div className="swiper-button-prev" onClick={() => swiper?.slidePrev()}></div>
                    <div className="swiper-button-next" onClick={() => swiper?.slideNext()}></div>
                </div>
            </Swiper>
        </div>
    );
}
